export default "__VITE_ASSET__52fd2e1e__"